<div class="arm">
    <div class="arm-indicadores">
        <div class="arm-indicador">
            <span class="arm-indicador-rotulo" pTooltip="1 GB = 1.000.000.000 bytes (o Windows usa 1.073.741.824)">Armazenado <i class="pi pi-info-circle"></i></span>
            <strong>{{ formataBytes(totalGeral) }}</strong>
            <small>{{ arquivosGeral | number }} arquivos</small>
        </div>
        <div class="arm-indicador">
            <span class="arm-indicador-rotulo">Clientes com arquivos</span>
            <strong>{{ todos.length | number }}</strong>
            <small>no Hábil Upload</small>
        </div>
        <button type="button" class="arm-indicador arm-indicador-botao arm-acima"
            [class.ativo]="situacao === 'acima'" (click)="filtraSituacao('acima')">
            <span class="arm-indicador-rotulo">Acima do limite</span>
            <strong>{{ qtdeAcima | number }}</strong>
            <small>clique para filtrar</small>
        </button>
        <button type="button" class="arm-indicador arm-indicador-botao arm-perto"
            [class.ativo]="situacao === 'perto'" (click)="filtraSituacao('perto')">
            <span class="arm-indicador-rotulo">Perto do limite</span>
            <strong>{{ qtdePerto | number }}</strong>
            <small>80% ou mais</small>
        </button>
    </div>

    <div class="p-fluid p-grid">
        <div class="p-col-12 p-md-6">
            <habil-label name="armBusca" label="Cliente">
                <input type="text" pInputText placeholder="Nome ou CNPJ" [(ngModel)]="busca" (ngModelChange)="filtrar()">
            </habil-label>
        </div>
        <div class="p-col-12 p-md-4">
            <habil-label name="armSituacao" label="Situação">
                <p-dropdown [options]="situacoes" [(ngModel)]="situacao" (onChange)="filtrar()" appendTo="body"></p-dropdown>
            </habil-label>
        </div>
        <div class="p-col-12 p-md-2 p-col-align-end">
            <button pButton type="button" icon="pi pi-refresh" label="Atualizar" [disabled]="carregando" (click)="carregar()"></button>
        </div>
    </div>

    <div *ngIf="erro" class="p-error arm-erro">{{ erro }}</div>

    <p-table [value]="lista" [loading]="carregando" [paginator]="true" [rows]="50" [rowsPerPageOptions]="[25, 50, 100]"
        sortField="total" [sortOrder]="-1" selectionMode="single" (onRowSelect)="abrir($event.data)"
        styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines">
        <ng-template pTemplate="header">
            <tr>
                <th pSortableColumn="nome">Cliente <p-sortIcon field="nome"></p-sortIcon></th>
                <th pSortableColumn="quantidade" class="arm-num">Arquivos <p-sortIcon field="quantidade"></p-sortIcon></th>
                <th pSortableColumn="total" class="arm-num">Utilizado <p-sortIcon field="total"></p-sortIcon></th>
                <th pSortableColumn="limite" class="arm-num">Limite <p-sortIcon field="limite"></p-sortIcon></th>
                <th pSortableColumn="percentual" style="width: 220px;">Uso <p-sortIcon field="percentual"></p-sortIcon></th>
                <th pSortableColumn="ultimo" style="width: 150px;">Último envio <p-sortIcon field="ultimo"></p-sortIcon></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-c>
            <tr [pSelectableRow]="c">
                <td>
                    <div class="arm-cliente">{{ c.nome || 'Sem cadastro na Central' }}</div>
                    <small class="arm-apagado">{{ c.cnpj }}</small>
                </td>
                <td class="arm-num">{{ c.quantidade | number }}</td>
                <td class="arm-num">{{ formataBytes(c.total) }}</td>
                <td class="arm-num">{{ formataBytes(c.limite) }}</td>
                <td>
                    <div class="arm-uso">
                        <div class="arm-barra"><span [class]="'arm-barra-' + c.situacao" [style.width.%]="larguraBarra(c.percentual)"></span></div>
                        <span class="arm-uso-texto" [class]="'arm-texto-' + c.situacao">{{ c.percentual | number: '1.0-1' }}%</span>
                    </div>
                </td>
                <td>{{ c.ultimo | date: 'dd/MM/yyyy HH:mm' }}</td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr><td colspan="6">Nenhum cliente encontrado.</td></tr>
        </ng-template>
    </p-table>
</div>

<p-dialog [header]="cliente?.nome || cliente?.cnpj" [(visible)]="mostraCliente" [modal]="true"
    [style]="{ width: '80vw' }" [breakpoints]="{ '960px': '96vw' }" [dismissableMask]="true" [draggable]="false">
    <div *ngIf="cliente" class="arm-detalhe">
        <div class="arm-detalhe-topo">
            <div class="arm-detalhe-uso">
                <div class="arm-detalhe-numeros">
                    <strong>{{ formataBytes(cliente.total) }}</strong>
                    <span class="arm-apagado">de {{ formataBytes(cliente.limite) }} · {{ cliente.quantidade | number }} arquivos · CNPJ {{ cliente.cnpj }}</span>
                </div>
                <div class="arm-barra arm-barra-grande"><span [class]="'arm-barra-' + cliente.situacao" [style.width.%]="larguraBarra(cliente.percentual)"></span></div>
                <small [class]="'arm-texto-' + cliente.situacao">
                    {{ cliente.percentual | number: '1.0-1' }}% usado<span *ngIf="cliente.situacao === 'acima'"> · passou do limite</span>
                </small>
            </div>
            <div class="arm-limite">
                <habil-label name="armLimite" label="Limite (GB)">
                    <p-inputNumber [(ngModel)]="limiteGb" [min]="0" [maxFractionDigits]="2" locale="pt-BR" [disabled]="!cliente.registroId"></p-inputNumber>
                </habil-label>
                <button pButton type="button" label="Salvar limite" class="p-button-success"
                    [disabled]="salvandoLimite || !cliente.registroId" (click)="salvarLimite()"></button>
                <small *ngIf="!cliente.registroId" class="arm-apagado">Cliente sem cadastro na Central.</small>
                <small *ngIf="mensagemLimite" class="arm-texto-ok">{{ mensagemLimite }}</small>
                <small *ngIf="erroLimite" class="p-error">{{ erroLimite }}</small>
            </div>
        </div>

        <div class="arm-pastas">
            <p-skeleton *ngIf="carregandoResumo" width="100%" height="56px"></p-skeleton>
            <button type="button" *ngFor="let p of resumo?.pastas" class="arm-pasta"
                [class.ativo]="filtroArquivos.pasta === p.pasta" (click)="filtraPasta(p.pasta)">
                <span>{{ nomePasta(p.pasta) }}</span>
                <strong>{{ formataBytes(p.total) }}</strong>
                <small>{{ p.quantidade | number }} arquivos</small>
            </button>
        </div>

        <div class="p-fluid p-grid">
            <div class="p-col-12 p-md-5">
                <habil-label name="armArqBusca" label="Nome do arquivo">
                    <input type="text" pInputText [(ngModel)]="filtroArquivos.busca" (keyup.enter)="buscarArquivos(0)">
                </habil-label>
            </div>
            <div class="p-col-6 p-md-3">
                <habil-label name="armArqPasta" label="Pasta">
                    <p-dropdown [options]="pastaOpcoes" [(ngModel)]="filtroArquivos.pasta" (onChange)="buscarArquivos(0)" appendTo="body"></p-dropdown>
                </habil-label>
            </div>
            <div class="p-col-6 p-md-2">
                <habil-label name="armArqOrdem" label="Ordem">
                    <p-dropdown [options]="ordens" [(ngModel)]="filtroArquivos.ordem" (onChange)="buscarArquivos(0)" appendTo="body"></p-dropdown>
                </habil-label>
            </div>
            <div class="p-col-12 p-md-2 p-col-align-end">
                <button pButton type="button" label="Buscar" [disabled]="carregandoArquivos" (click)="buscarArquivos(0)"></button>
            </div>
        </div>

        <div *ngIf="erroArquivos" class="p-error arm-erro">{{ erroArquivos }}</div>

        <p-table [value]="arquivos" [lazy]="true" [paginator]="true" [rows]="qtdePorPagina" [first]="inicioArquivos"
            [totalRecords]="totalArquivos" [rowsPerPageOptions]="[25, 50, 100]" (onLazyLoad)="paginarArquivos($event)"
            [loading]="carregandoArquivos" styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines">
            <ng-template pTemplate="header">
                <tr>
                    <th>Arquivo</th>
                    <th style="width: 190px;">Pasta</th>
                    <th class="arm-num" style="width: 110px;">Tamanho</th>
                    <th style="width: 150px;">Enviado em</th>
                    <th style="width: 90px;">Acesso</th>
                    <th style="width: 60px;"></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-a>
                <tr>
                    <td class="arm-arquivo" [title]="a.s3Filename">{{ a.filename }}</td>
                    <td>{{ nomePasta(a.pasta) }}</td>
                    <td class="arm-num">{{ formataBytes(a.size) }}</td>
                    <td>{{ a.createdAt | date: 'dd/MM/yyyy HH:mm' }}</td>
                    <td>{{ a.isPrivate ? 'Privado' : 'Público' }}</td>
                    <td>
                        <button pButton type="button" icon="pi pi-external-link" class="p-button-text p-button-sm"
                            pTooltip="Abrir" [disabled]="abrindo === a.id" (click)="abrirArquivo(a)"></button>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr><td colspan="6">Nenhum arquivo encontrado.</td></tr>
            </ng-template>
        </p-table>
    </div>
</p-dialog>
